import * as React from "react";
export const ContentPage = ({ children }) => (React.createElement("div", { className: "flex flex-row flex-1 app-shell" }, children));
//# sourceMappingURL=ContentPage.js.map